import { useGrowthBook } from '@growthbook/growthbook-react';
import { useEffect } from 'react';
import videojs from 'video.js';

export function useVideoJsDebugFlag() {
  const growthbook = useGrowthBook();

  useEffect(() => {
    if (growthbook?.isOn('app__debug_videojs')) {
      videojs.log.level('all');
    }
  }, [growthbook]);
}
